import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import Styles from '../../../common/styles'
import Y from '../../../y18n'
import * as gdprActions from '../../../store/gdpr'

const mapStateToProps = state => ({
  gdpr: state.gdpr
})

const mapDispatchToProps = dispatch => ({
  gdprActions: bindActionCreators(gdprActions, dispatch)
})

class SearchInformation extends Component {
  state = {
    email: '',
    phoneNumber: ''
  }

  submitSearch = e => {
    e.preventDefault()
    this.props.gdprActions.searchInformation(this.state.email, this.state.phoneNumber)
  }

  inputChanged = name => e => {
    this.setState({ [name]: e.target.value })
  }

  render () {
    const { classes, gdpr } = this.props
    return (
      <Paper>
        {gdpr.loading && <LinearProgress />}
        <div className={classes.content}>
          <div className={classes.textRow}>
            <Typography variant='title'>
              {Y`GDPR`}
            </Typography>
            <Typography variant='subheading'>
              {Y`Use this form to list all information related to a specific user. Search by email or phone number`}
            </Typography>
          </div>
          <form className={classes.searchBar} onSubmit={e => this.submitSearch(e)}>
            <div className={classes.flexRow}>
              <TextField
                margin='normal'
                className={classes.flexItemLeft}
                label={Y`Email`}
                type='text'
                value={this.state.email}
                onChange={this.inputChanged('email')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
              />
              <TextField
                margin='normal'
                className={classes.flexItemRight}
                label={Y`Phone number`}
                type='text'
                value={this.state.phoneNumber}
                onChange={this.inputChanged('phoneNumber')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
              />
            </div>
            <div className={classes.buttonRow}>
              <Button variant='raised' color='primary' style={{ color: '#fff' }} type='submit'>{Y`Search`}</Button>
            </div>
          </form>
        </div>
      </Paper>
    )
  }
}

SearchInformation = connect(mapStateToProps, mapDispatchToProps)(SearchInformation)
export default withStyles(Styles)(SearchInformation)



// WEBPACK FOOTER //
// ./src/pages/gdpr/containers/search-information.js